export const findImageData = (nodes, imageName) => {
    return nodes.find((item) => imageName === item.resize.originalName);
};
